import axios from "axios";
import {config} from "@commons/config.instance";
import {addBaseQueryParams, BaseQueryParams} from "@commons/utils/APIParams";
import {DocType} from "@commons/mapping/UniversalDocRecord";

//Anteprima doc GET https://fpnet2.ericed.it/Docs2022/doc/m-files/contratto/43801-0/file/3310588-3-3309615?auth_token=e0729b14ea967180ffc59a4c6f7d5d12&contentDisposition=inline
//Download doc GET https://fpnet2.ericed.it/Docs2022/doc/m-files/contratto/43801-0/file/3310588-3-3309615?auth_token=e0729b14ea967180ffc59a4c6f7d5d12&nowId=1690209713751&isValid=true&type=attachment

export interface DocsParams extends BaseQueryParams {
    idDip: number | null;
    sezione: DocType | '';
}

export class DocsParams {
    static isValid = (p: DocumentoParams) => (p.idDip !== 0 && p.idDip !== null);
}

export interface DocumentoParams extends DocsParams {
    anteprima: boolean;
}


//GET 5 Recenti e badges http://fpnet.local/Docs2022/doc/m-files/contratto/86288/file-ex?sezione=&auth_token=ae79cac805234850684660ec7dff9204&nowId=1688633441746&anteprima=true&mode=DataTables&view=Grid
export const getDocsAndBadges = (filter: DocumentoParams) => {
    let params: string[] = addBaseQueryParams(filter);
    if (filter.sezione !== undefined) params.push('sezione=' + filter.sezione);
    if (filter.anteprima) params.push('anteprima=' + filter.anteprima);

    const url = config.getBaseUrl('Docs') + `/doc/m-files/contratto/${filter.idDip}/file-ex?${params.length > 0 ? encodeURI(params.join("&")) : ''}`;

    return axios(url).then(res => res.data);
}


//GET Cedolini http://fpnet.local/Docs2022/doc/m-files/contratto/86288/file-ex?sezione=CEDOLINI&auth_token=ae79cac805234850684660ec7dff9204&nowId=1688633138336&mode=DataTables&nowId=1688633138305&view=Grid
//GET Certificazioni http://fpnet.local/Docs2022/doc/m-files/contratto/86288/file-ex?sezione=CERTIFICAZIONI&auth_token=ae79cac805234850684660ec7dff9204&nowId=1688633333346&mode=DataTables&nowId=1688633333324&view=Grid
//GET Comunicazioni http://fpnet.local/Docs2022/doc/m-files/contratto/86288/file-ex?sezione=COMUNICAZIONI&auth_token=ae79cac805234850684660ec7dff9204&nowId=1688633354197&mode=DataTables&nowId=1688633354181&view=Grid
//GET Documenti pubblici http://fpnet.local/Docs2022/doc/m-files/contratto/86288/file-ex?sezione=DOC_PUBBLICI&auth_token=ae79cac805234850684660ec7dff9204&nowId=1688633382959&mode=DataTables&nowId=1688633382951&view=Grid
//GET Altri documenti http://fpnet.local/Docs2022/doc/m-files/contratto/86288/file-ex?sezione=ALTRI&auth_token=ae79cac805234850684660ec7dff9204&nowId=1688633428205&mode=DataTables&nowId=1688633428204&view=Grid

export interface MFilesDocParams {
    bygroup: boolean,
    mySearch: string,
}

//GET per +Documenti NELLA SEZIONE "Altri documenti": http://fpnet.local/Docs2022/doc/m-files/sistema/classe?auth_token=ae79cac805234850684660ec7dff9204&nowId=1688634286276&bygroup=true&search=Documento+o+singola+comunicazione
export const listClassiDocs = (filter: MFilesDocParams) => {
    const url = config.getBaseUrl('Docs') + `/doc/m-files/sistema/classe?bygroup=${filter.bygroup}&search=${filter.mySearch}`;

    return axios(url).then(
        (res) => {
            if (res.status === 200)
                return res.data;
            else
                return [];
        },

        (res) => {
            throw res;
        });
}